import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ContainerForm } from '@/components/Form/ContainerForm'
import { updatecentreConfiguration } from '@/store/centreConfigurations/actions'
import { updateCentre } from '@/store/centres/actions'
import { yupResolver } from '@hookform/resolvers/yup'

import { formDefaultValues } from './formConfig'
import { FormContent } from './formContent'
import { formValidationSchema } from './formValidation'

import s from './styles.module.scss'

const TabGeneral = () => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const centreDetail = useSelector((state) => state.centres.centreProfile)
  const centreConfiguration = useSelector((state) => state.centreConfigurations.centreConfigurationDetail)

  const auxCentreDetail = {
    ...centreDetail,
    centreConfiguration: centreConfiguration,
  }

  const handleSubmit = async (data) => {
    setIsLoading(true)
    const auxCentreConfiguration = { ...data.centreConfiguration }
    //le seteo manual el valor de las imagenes por que la funcion que actuliza las fotos no esta vinculada al formulario
    data.logo = centreDetail.logo
    data.image = centreDetail.image

    try {
      if (centreDetail) {
        await dispatch(updatecentreConfiguration(auxCentreConfiguration))
        await dispatch(updateCentre(data))
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ContainerForm
      className={s.containerForm}
      onSubmit={(data) => handleSubmit(data)}
      defaultValues={{
        ...formDefaultValues,
        ...auxCentreDetail,
        city: centreDetail?.city?.formatted_address || centreDetail?.city,
      }}
      resolver={yupResolver(formValidationSchema)}
    >
      <FormContent isLoading={isLoading} />
    </ContainerForm>
  )
}

export default TabGeneral
